import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { RoleAssignments } from '../features/selfservice/roleAssignments/components'
import FallbackErrorMessage from '../utils/errors/FallbackMessage'

export const RoleAssignmentsPage: React.FC = () => {
  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <RoleAssignments />
    </ErrorBoundary>
  )
}
